import * as $ from "jquery";

export const $body     = $(document.body);
export const $document = $(document);
export const $window   = $(window);
import * as $ from "jquery";

export const $body     = $(document.body);
export const $document = $(document);
export const $window   = $(window);
